import FieldUser from "../user/user"
import FieldConfig from "../../proto/field-config"
import {PopoverMenuItemType} from "../../../gd-components/popover-menu/popover-menu/const";

export default class FieldUserReportsTo extends FieldUser {

    public reportsToUserId: ID | null

    constructor(config: FieldConfig) {
        super(config)

        this.typeLabel          = "User"
        this.typeDescription    = "Company user select field with reports to"

        this.reportsToUserId    = _.get(config, "reportsToUserId", null)
    }

    getOptions() :Options {

        //special options
        const specialOptions = [];

        if (!!this.reportsToUserId) {

            const reportsToUser = gd.session.companyUsers.getByUserId(this.reportsToUserId)

            if (!!reportsToUser) {

                _.remove(this.options || [], (option)=>option.value === this.reportsToUserId)

                specialOptions.push({
                    value   : reportsToUser.user.id,
                    // label   : "Reports to ({0})".f(reportsToUser.user.name)
                    label   : reportsToUser.user.name + " (Direct manager)"
                })

                specialOptions.push({
                    type    : PopoverMenuItemType.SEPARATOR
                })
            }
        }

        // if (this.arValueOption) {
        //     specialOptions.push({value: '{actionRequiredUserId}',  icon: "i5-user", label: this.arValueOptionLabel})         // add action required value option if required
        // }
        //
        // if (this.assignedToValueOption) {
        //     specialOptions.push({value: '{assignedToUserId}',      icon: "i5-user", label: this.assignedToValueOptionLabel}) // add assigned to value option if required
        // }
        //
        // if (this.currentUserValueOption) {
        //     specialOptions.push({
        //         value: '{currentUserId}',
        //         icon: "i5-user",
        //         label: "Current user"
        //     })
        // }

        // to prevet ts error as this.options can be null
        if (!this.options) {
            return specialOptions
        }

        return specialOptions.concat(this.options);
    }

}
